import React from 'react';

const Card = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div className={`bg-bg rounded-xl p-6 border border-fg-100 ${className}`} {...props} />
);

export default Card;
